export const hasRoles = (user, allowedRoles = []) => {
  const Auth0Constants_DEFAULTROLEURI = 'https://mydeserve.com/roles'
  const roles = user?.[Auth0Constants_DEFAULTROLEURI] || [];
  return allowedRoles.length === 0 || roles.some(role => allowedRoles.includes(role));
};